import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { Threat } from '@/api/rest/resources/conservation';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import {
  DDChartData,
  DegradationDriversHistoricalChart,
  INTACTNESS_KEY,
  ThreatsTimeSeries,
} from '@/pages/shared/projects/pages/project/pages/conservation/BU/components/Charts/DegradationDriversHistorical';
import { useGetTrendLabel } from '@/pages/shared/projects/pages/project/pages/conservation/BU/hooks/useGetTrendLabel';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';

export const GraphTile = () => {
  const { t } = useTranslation();

  const threatsTimeseries = useFact<{ value: Record<string, number> }>('r1_conservation_threats_ts');
  const baselineYear = useFact<{ value: number }>('r1_conservation_threats_baseline_year').value;

  const trendLabel = useGetTrendLabel({
    trendChangeFact: 'r1_conservation_threats_change_percentage',
  });

  const threats = Object.keys(Threat).map((key) => key as Threat);

  const chartData: DDChartData[] = Object.entries(threatsTimeseries.value).map(([yearString, value]) => {
    const threatValues = Object.fromEntries(
      threats.map((threat) => [threat, value[`${threat}`] ?? null]),
    ) as ThreatsTimeSeries;

    return { date: new Date(yearString), ...threatValues, [INTACTNESS_KEY]: value[`${INTACTNESS_KEY}`] };
  });

  return (
    <Stack center spacing={6} data-testid='degradation-drivers-historic-graph-tile'>
      <ChartHeading
        heading={t('shared.ncaDetail.habitatIntactness.degradationDriversHistoric.chartHeading', {
          year: baselineYear,
        })}
        className='w-full px-6 sm:px-0'
      />
      <DegradationDriversHistoricalChart data={chartData} trendLabel={trendLabel} />
    </Stack>
  );
};
